import { useSelector } from 'react-redux';
import useFetch from './useFetch';
import AccountService from '../services/account-service';
import useOrganisation from './useOrganisation';
import { useLocation } from 'react-router-dom';

const noop = async () => ({});

const getOrgFromPath = location => {
  if (location.pathname.match(/\/o\//g)) {
    return location.pathname.split('/')[2];
  }

  return null;
};

function useUserInfo() {
  const user = useSelector(state => state.loginReducer);
  const location = useLocation();
  const { manager, partner } = useOrganisation(getOrgFromPath(location));
  const userInfo = useFetch(user.isLoggedIn ? AccountService.getUserInfo : noop).data;

  const isPartnerSubscribed =
    !!partner && !!partner.subscriber && partner.subscriber?._id === user.userId;

  return {
    ...userInfo,
    isManager: userInfo.isManager || !!manager ? manager._id === user.userId : false,
    isPartnerSubscribed,
  };
}

export default useUserInfo;
